var headerTop = $('.header-top').innerHeight() ;
$(document).ready(function () {

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $('.back-to-top').click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 100);
        return false;
    });


    $("form[method='post']").on("submit", function(ev) {
        setButtonLoading($(this));
    });


    initMobileMenu();
})

//add simple support for background images:
//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    imgToBG($(".bg-img"), ".img-bg");
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});


window.captchaCallback = function(response) {
    $(".g-recaptcha").val(response);
};

$(window).on('scroll', function () {

    var header = $('.header-bottom');

    stickyHeader(header, headerTop);
    stickyHeaderMobile(header, headerTop)

});

function initMobileMenu(){
    if($("#mobile-menu").length > 0) {
        var menu = new MmenuLight($("#mobile-menu").get(0));

        var navigator = menu.navigation({
        });

        var drawer = menu.offcanvas({
            position: 'left'
        });

        $('a[href="#mobile-menu"]').on("click", function(ev) {
            $('#mobile-menu').css("display", "block");
            drawer.open();

            ev.preventDefault();
            ev.stopPropagation();
        });
    }
}

function stickyHeader(header, sticky) {
    if ($(window).scrollTop() > sticky) {
        header.addClass('sticky');
        $('#sticky-nav-makbest').show()


    } else {
        header.removeClass('sticky');
        $('#sticky-nav-makbest').hide()

    }
}

function stickyHeaderMobile(header, sticky) {
    if ($(window).scrollTop() > sticky) {
        header.addClass('sticky');
    } else {
        header.removeClass('sticky');
    }
}

function imgToBG(bgClass, imageClass) {
    if (bgClass.length > 0) {
        bgClass.each(function() {
            var img = $(this).find(imageClass).eq(0);
            $(this).attr('data-bg', img.attr("src"));
            img.hide();
        });
    }
}

function setButtonLoading($this) {
    var submitButton = $this.find('button[type="submit"]').not(".no-loading");

    if (submitButton.length) {
        submitButton.prop("disabled", true).append('<i class="fas fa-spinner-third fa-spin ml-2"></i>');
    }
}



function reSizeCaptcha(parent = "") {
    if ($(parent + ".g-recaptcha").length) {
        var width = $(parent + ".g-recaptcha")
            .parent()
            .width();

        if (width > 150 && width < 302) {
            var scale = (width - 5) / 302;

            $(parent + ".g-recaptcha").css("transform", "scale(" + scale + ")");
            $(parent + ".g-recaptcha").css(
                "-webkit-transform",
                "scale(" + scale + ")"
            );
        } else {
            $(parent + ".g-recaptcha").css("transform", "unset");
            $(parent + ".g-recaptcha").css("-webkit-transform", "unset");
        }
    }
}

